import type { ReactElement, ReactNode } from 'react';
import { Children, cloneElement } from 'react';

import { classFilter } from '@shieldpay/theme-provider-ui/utilities';

import { Box } from '../box/box';
import type { TextProps } from '../text/text';
import { Text } from '../text/text';

import * as styles from './text-list.css';

export interface TextListItemProps
  extends Pick<TextProps, 'variant' | 'color'> {
  children: ReactNode;
}

export interface TextListProps extends TextListItemProps {
  ordered?: boolean;
}

export const TextListItem = ({
  children,
  variant,
  color,
}: TextListItemProps) => (
  <Text color={color} Component="li" variant={variant} className={styles.item}>
    {children}
  </Text>
);

export const TextList = ({
  children,
  ordered = false,
  variant = 'body150',
  color,
  ...boxProps
}: TextListProps) => {
  const ListComponent = ordered ? 'ol' : 'ul';

  return (
    <Box
      Component={ListComponent}
      variant="initial"
      className={classFilter([styles.base, styles.type[ListComponent]])}
      {...boxProps}
    >
      {Children.map(children, (child) =>
        cloneElement(child as ReactElement<TextListItemProps>, {
          variant,
          color,
        }),
      )}
    </Box>
  );
};

TextList.Item = TextListItem;
